export default (viewport: SVGElement, matrix: DOMMatrix) => {
  const classList = Array.from(viewport.classList);

  if (matrix.a === 1 && matrix.d === 1 && classList.includes('has-zoom')) {
    viewport.classList.remove('has-zoom');
  } else if (
    matrix.a !== 1 &&
    matrix.d !== 1 &&
    !classList.includes('has-zoom')
  ) {
    viewport.classList.add('has-zoom');
  }
};
